import React from 'react';
import svgs from './svgs';

export interface IconProps {
  name: string;
  className?: string;
  size?: number;
  color?: string;
  style?: React.CSSProperties;
}

const Icon = ({
  name = 'heart',
  className,
  size,
  color,
  style,
  ...props
}: IconProps) => {
  const Comp = svgs[name] || svgs._missing;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      style={{
        width: size,
        height: size,
        fill: color,
        ...style,
      }}
      {...props}>
      <Comp />
    </svg>
  );
};

export default Icon;
